import { TrainingConfiguration } from "./components/TrainingConfiguration";
import React, { useCallback, useEffect, useState } from "react";
import classes from "./App.module.css";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import PickleToQueryString from "./store/PickleToQueryString";
import CreateScalePage from "./components/CreateScalePage/CreateScalePage";
import MenuBar from "./components/MenuBar/MenuBar";
import RefineScalePage from "./components/RefineScalePage/RefineScalePage";
import PublishScalePage from "./components/PublishScalePage/PublishScalePage";
import UnpickleFromQueryString from "./store/UnpickleFromQueryString";
import SupportMePage from "./components/SupportMePage/SupportMePage";
import LibraryWorkspace from "./components/LibraryPage/LibraryWorkspace";
import { mainActions } from "./store";
import PrivacyPage from "./components/PrivacyPage/PrivacyPage";
import PreviewScalePage from "./components/PublishScalePage/PreviewScalePage";
import TermsOfUsePage from "./components/TermsOfUsePage/TermsOfUsePage";
import EarTrainerPage from "./components/EarTrainerPage/EarTrainerPage";
import RenderData from "./store/RenderData";
import FretboardPage from "./components/FretboardPage/FretboardPage";
import BlogPage from "./components/Blog/BlogPage";
import MyChartsPage from "./components/MyChartsPage/MyChartsPage";
import AccountPage from "./components/AccountPage/AccountPage";
import AdminPage from "./components/AdminPage/AdminPage";
import MetronomePage from "./components/MetronomePage/MetronomePage";
import AnalyticsConsent from "./privacy/AnalyticsConsent";

function App({ page }) {
  const [chartLoadError, setChartLoadError] = useState(false);
  // set a default state
  const menuSelected = useSelector((state) => state.menuSelected);
  const isQueryStringUnpacked = useSelector(
    (state) => state.isQueryStringUnpacked
  );

  //const [menuSelected, setMenuSelected] = useState(1);

  const location = useLocation();
  const dispatch = useDispatch();

  const setMenuSelected = useCallback(
    (selected) => {
      dispatch(mainActions.setMenuSelected(selected));
    },
    [dispatch]
  );

  useEffect(() => {
  }, []);

  useEffect(() => {
    // if we have data then go to refine.
    if (page === "home" && location.search.length && !isQueryStringUnpacked) {
      setMenuSelected(2);
    } else if (menuSelected === 0) {
      setMenuSelected(1);
    }
  }, [location, page, menuSelected, setMenuSelected, isQueryStringUnpacked]);

  useEffect(() => {
    if (page === "home") {
      if (menuSelected === 2 && !isQueryStringUnpacked) {
        if (location.search) {
          const loaded = UnpickleFromQueryString(location.search, dispatch);
          setChartLoadError(!loaded);
          if (!loaded) setMenuSelected(1);
        }
        dispatch(mainActions.setIsQueryStringUnpacked(true));
      }
    }
    if (page === "publish") {
      setChartLoadError(!UnpickleFromQueryString(location.search, dispatch));
    }
  }, [menuSelected, page, isQueryStringUnpacked, dispatch, location.search, setMenuSelected]);

  const onClickPublishHandler = () => {
    const url = `/${location.search}`;
    window.location = url;
  };

  const homePageActive = page === "home" && menuSelected === 1;
  const libraryPageActive = page === "library";
  const refineScalePageActive = page === "home" && menuSelected === 2;
  const previewScalePageActive = page === "home" && menuSelected === 3;
  const trainingPageActive = page === "training";
  const fretboardPageActive = page === "fretboard";
  const blogPageActive = page === "blog";
  const supportMePageActive = page === "support";
  const publishScalePageActive = page === "publish";
  const privacyPageActive = page === "privacy";
  const termsPageActive = page === "terms";
  const metronomePageActive = page === "metronome";

  useEffect(() => {
    dispatch(mainActions.setRefineHistoryEnabled(
      page === "home" && [2, 3].includes(menuSelected) && isQueryStringUnpacked
    ));
  }, [dispatch, page, menuSelected, isQueryStringUnpacked]);

  useEffect(() => {
    // refine data can only be regenerated when the Create Menu is active
    dispatch(mainActions.setProtectRefineData(!homePageActive));

  },[homePageActive,dispatch]);

  const chartLoadErrorMessage = chartLoadError && (
    <p role="alert">
      This chart link is invalid or incomplete. Please check the link and try again.
    </p>
  );

  return (
    <>
      <AnalyticsConsent />
      {!publishScalePageActive && (
        <>
          <MenuBar page={page} />
          <div className={classes.body}>
            {chartLoadErrorMessage}
            {homePageActive && <CreateScalePage />}
            {libraryPageActive && <LibraryWorkspace />}
            {refineScalePageActive && <RefineScalePage />}
            {supportMePageActive && <SupportMePage />}
            {previewScalePageActive && (
              <PreviewScalePage onClick={onClickPublishHandler} />
            )}
            {privacyPageActive && <PrivacyPage />}
            {termsPageActive && <TermsOfUsePage />}
            {trainingPageActive && <TrainingConfiguration key="ear" name="ear"><EarTrainerPage /></TrainingConfiguration>}
            {fretboardPageActive && <TrainingConfiguration key="fretboard" name="fretboard"><FretboardPage /></TrainingConfiguration>}
            {blogPageActive && <BlogPage />} 
            {metronomePageActive && <MetronomePage />}
            {page === "account" && <AccountPage />}
            {page === "admin" && <AdminPage />}
            {page === "my-charts" && <MyChartsPage />}
          </div>
        </>
      )}
      {publishScalePageActive && chartLoadErrorMessage}
      {publishScalePageActive && !chartLoadError && (
          <PublishScalePage onClick={onClickPublishHandler} />
      )}
      {menuSelected === 2 && <PickleToQueryString />}
      <RenderData />
    </>
  );
}

export default App;
